import { render } from "./HomeStudent.vue?vue&type=template&id=6130c4e5"
import script from "./HomeStudent.vue?vue&type=script&lang=js"
export * from "./HomeStudent.vue?vue&type=script&lang=js"

import "./HomeStudent.vue?vue&type=style&index=0&id=6130c4e5&lang=scss"

import exportComponent from "F:\\work\\angren\\cabinet\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__